import { render, staticRenderFns } from "./PnetMessageListView.vue?vue&type=template&id=e5d97404"
import script from "./PnetMessageListView.vue?vue&type=script&lang=js"
export * from "./PnetMessageListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5d97404')) {
      api.createRecord('e5d97404', component.options)
    } else {
      api.reload('e5d97404', component.options)
    }
    module.hot.accept("./PnetMessageListView.vue?vue&type=template&id=e5d97404", function () {
      api.rerender('e5d97404', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pnetmessage/PnetMessageListView.vue"
export default component.exports